export default "__VITE_ASSET__4V7s8hzP__"